export enum COST_DETAILS_TYPE {
  REDPOINTS = 'RedPoints',
}
